<template>


<div class="modal fade pt-lg-5" id="setupModal" tabindex="-1" role="dialog" aria-labelledby="setupModal" aria-hidden="true">
  <div class="modal-dialog modal-lg pt-lg-5" role="document">
    <div class="modal-content">
      <div class="modal-body">
        


          <div id="carouselSetupWizard" class="carousel slide" >
            <div class="carousel-inner">
              <div class="carousel-item active text-center">

                <p><img class="matilda" src="images/matilda.svg"></p>
                <p class="lead mb-1">Hi {{ settings.first_name }}, I’m Matilda.</p>
                <p class="lead mb-1">I’m here to get set up and building SizzleDecks as quickly as possible.</p>
                <p class="lead">Sound good to you?</p>
                <button type="button" class="btn btn-primary" @click="wizardNext">Great! Let's Get Started</button>

              </div>

 

              <div class="carousel-item text-center">
                
                  <p class="lead">First, let's check a few things. I have your company name as:</p>
                  <h5 class="font-weight-bold">{{ settings.company_name }}</h5> 
                  <p class="lead">Is that correct?</p>

                  
                  
                  <button type="button" class="btn btn-secondary" @click="showCompanyName">No</button>
                  <button type="button" class="btn btn-primary" @click="wizardNext">Yes</button>


                  <div class="collapse no-toggle " id="collapseCompanyName">
                    <hr />
                    <h5 class="text-center font-weight-bold">Ok, Please enter your company name below:</h5>
                    <input type="text" class="form-control margin-bottom-20" id="companyName" ref="companyName" placeholder="Company Name" :value="settings.company_name">
                    <div class="messagebox"></div>
                    <p class="text-center pt-3"><button type="button" class="btn btn-primary" @click="saveName">Save and Continue</button></p>
                  </div>

                  <div class="collapse no-toggle" id="collapseCompanyNameContinue">
                    <hr />
                    <p class="text-center"><button type="button" class="btn btn-primary" @click="wizardNext"></span> Continue</button></p>
                  </div>

              </div>

              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Please upload your company logo.</h5>

                  <div class="row justify-content-center">

                    <div class="col-4">

                      <company-logo v-if="settings_loaded" input-id="company_logo" name="company_logo" :image="settings.logo" ref="company_logo" :disableLibraryButton="true" uploadButtonText="Upload Logo"></company-logo>

                    </div>

                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6">
                      <div class="matilda-chat"><div class="chat-bubble"><span class="lead">If possible, it's best to use a landscape logo on a white or transparent background.</span></div></div>
                    </div>
                  </div>
                  <div class="row justify-content-center">

                    <div class="col-12">

                      

                      <div class="d-flex flex-row-reverse justify-content-between">
                          <button type="button" class="btn btn-primary"   @click="saveLogo">Next</button>
                          <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                      </div>  

                    </div>
                  </div>

              </div>

              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Thanks. Now please select your company accent colour using the colour picker below.</h5>

                  <div class="form-row">
                      <div class="form-group col text-center mt-4 mb-3">
                                                   
                          <company-color-picker v-if="settings_loaded" name="company_accent_color" ref="company_accent_color" :value="settings.accent_color"></company-color-picker>
                          
                      </div>
                  </div>

                  <div class="row justify-content-center">
                    <div class="col-6">
                      <div class="matilda-chat"><div class="chat-bubble"><span class="lead">This will automatically be applied to card headlines, buttons and some card backgrounds.</span></div></div>
                    </div>
                  </div>

 

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveColors">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>
              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Please upload your deck background or choose one from our library.</h5>

                  <div class="row justify-content-center">

                    <div class="col-6">

                      <deck-background input-id="background" name="background" image="/storage/backgrounds/darkwood.jpg" ref="background"></deck-background>

                    </div>
                  </div>

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveBackground">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>
 

              <div class="carousel-item">
                    
                  <h5 class="text-center font-weight-bold">Finally, please upload a picture of yourself for your profile picture.</h5>

                  <div class="row justify-content-center">

                    <div class="col-6">
                  
                      <profile-image :disableLibraryButton="true" input-id="profile_pic" name="profile_pic" image="/images/default/avatar.png" ref="profile_pic"></profile-image>

                    </div>

                  </div>

                  <div class="d-flex flex-row-reverse justify-content-between">
                      <button type="button" class="btn btn-primary" @click="saveProfilePicture">Next</button>
                      <button type="button" class="btn btn-secondary" @click="wizardPrev">Back</button>
                  </div>  

              </div>

              <div class="carousel-item text-center">

                <h5 class="text-center font-weight-bold">All done! Now let’s make a SizzleDeck!</h5>


                <p class="lead">(You can still change your info in Company Settings.)</p>
                <button type="button" class="btn btn-primary" @click="redirectToNewDeck">Great! Let’s Get Started.</button>

              </div>

            </div>
          </div>
          </div>


        
      </div>
    
    </div>
  </div>
</div>

</template>

<script>

import axios from 'axios';
import Noty from 'noty';

export default {

  mounted() {

      var vm = this;

      // Get Defaults / Inital
      axios.get('/deck/defaults/').then(response => {

        vm.settings = response.data;

        vm.settings_loaded = true;

        $('.carousel').carousel({
          interval: false,
          wrap: false,
        })
        $('#setupModal').modal({
            backdrop: 'static',
            keyboard: false,
            show: true,
            focus: true
        });

      }).catch(function(error){ vm.handleError(error) });


      },
      data: function(){
        return {                
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          settings_loaded: false,
          settings:[],
        }
      },
      methods:{
        wizardNext: function(){
          $('#carouselSetupWizard').carousel('next');
        },
        wizardPrev: function(){
          $('#carouselSetupWizard').carousel('prev');
        },
        showCompanyName: function(){
          $('#collapseCompanyNameContinue').slideUp();
          $('#collapseCompanyName').slideDown();
        },
        showCompanyNameContinue: function(){
          $('#collapseCompanyName').slideUp();
          $('#collapseCompanyNameContinue').slideDown();
        },
        saveName: function(){

          var vm = this;

          axios.post('/setup',{company_name:vm.$refs.companyName.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ vm.handleError(error) });

          
        },
        saveLogo: function(){
          var vm = this;

          axios.post('/setup',{company_logo:vm.$refs.company_logo.$refs.company_logo.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ vm.handleError(error) });

        },
        saveColors: function(){

          var vm = this;

          axios.post('/setup',{
            accent_color:vm.$refs.company_accent_color.$refs.company_accent_color.value
          }).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ vm.handleError(error) });

        },
        saveBackground: function(){

          var vm = this;

          axios.post('/setup',{background:vm.$refs.background.$refs.background.value,profile_background:vm.$refs.background.$refs.background.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ vm.handleError(error) });

        },
        saveProfileBackground: function(){
          
          var vm = this;

          axios.post('/setup',{profile_background:vm.$refs.profile_background.$refs.profile_background.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ vm.handleError(error) });

        },
        saveProfilePicture: function(){
          
          var vm = this;

          axios.post('/setup',{profile_pic:vm.$refs.profile_pic.$refs.profile_pic.value}).then(response => {

              if(response.data.status == 'success'){
                $('#carouselSetupWizard').carousel('next');
              }else{
                vm.showNoty('error',response.data.message,3000);
              }               

          }).catch(function(error){ vm.handleError(error) });

        },
        redirectToNewDeck: function(){
          // Redirect
          window.location.href = '/deck/new';

        },
        handleError: function(error){

            if(error.response.status == '419'){
              this.showLoggedOutNoty();
            }else{
              this.showGeneralErrorNoty();
            }

        },
        showNoty: function(type='warning',message='',timeout=false){
          new Noty({
                    text: message,
                    type: type,
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: timeout
                }).show();
        },
        showGeneralErrorNoty: function(){
          new Noty({
                    text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
                    type: 'error',
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: false
                }).show();
        },
        showLoggedOutNoty: function(){
          new Noty({
              text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
              type: 'error',
              theme: 'bootstrap-v4',
              layout: 'topCenter',
              timeout: false
          }).show();
        },  



      }
}
</script>
